// extracted by mini-css-extract-plugin
export default {"footer":"vN3v2h6ZON42Pgeay0uu"};